import React from "react";
import logo from "../logo.svg";
import { useTranslation } from "react-i18next";
import "../i18n";

const Footer = () => {
  const { t } = useTranslation();

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <footer className="site-footer">
      <div className="page-container footer-layout">
        <div>
          <img
            src={logo}
            className="footer-logo"
            alt="L3 Route"
            width="115"
            height="24"
            loading="lazy"
            decoding="async"
          />
          <p>{t("footer_text")}</p>
        </div>
        <nav className="footer-nav" aria-label="Footer">
          <button type="button" onClick={() => scrollTo("services")}>{t("services")}</button>
          <button type="button" onClick={() => scrollTo("approach")}>{t("approach")}</button>
          <button type="button" onClick={() => scrollTo("contact")}>{t("contact")}</button>
        </nav>
        <p className="footer-copy">L3 Route © {new Date().getFullYear()}</p>
      </div>
    </footer>
  )
}

export default Footer;
